import type { EditorMode, ToolbarItem } from '../../types'

export const TOOLBAR_DEFAULTS: Record<EditorMode, ToolbarItem[]> = {
  track: ['mention', 'timestamp', 'timestamp-range', 'submit'],
  default: [
    'bold',
    'italic',
    'underline',
    'bullet-list',
    'ordered-list',
    'link',
  ],
  email: [
    'bold',
    'italic',
    'underline',
    'bullet-list',
    'ordered-list',
    'text-align',
    'link',
    'image',
    'heading',
    'font-size',
    'text-color',
    'bg-color',
    'merge-tag',
    'cta-button',
  ],
}

const SHARED_ITEMS: ToolbarItem[] = [
  'bold',
  'italic',
  'underline',
  'bullet-list',
  'ordered-list',
  'text-align',
  'link',
  'image',
  'heading',
  'font-size',
  'text-color',
  'bg-color',
  'mention',
  'submit',
]

const TRACK_ITEMS: ToolbarItem[] = ['timestamp', 'timestamp-range']
const EMAIL_ITEMS: ToolbarItem[] = ['merge-tag', 'cta-button']

export const MODE_ALLOWED: Record<EditorMode, Set<ToolbarItem>> = {
  track: new Set<ToolbarItem>([...SHARED_ITEMS, ...TRACK_ITEMS]),
  default: new Set<ToolbarItem>(SHARED_ITEMS),
  email: new Set<ToolbarItem>([...SHARED_ITEMS, ...EMAIL_ITEMS]),
}

export const ITEM_GROUPS: Record<ToolbarItem, string> = {
  bold: 'format',
  italic: 'format',
  underline: 'format',
  'bullet-list': 'list',
  'ordered-list': 'list',
  'text-align': 'align',
  link: 'link',
  image: 'link',
  heading: 'heading',
  'font-size': 'font-size',
  'text-color': 'color',
  'bg-color': 'color',
  'merge-tag': 'merge-tag',
  'cta-button': 'cta-button',
  mention: 'mention',
  timestamp: 'timestamp',
  'timestamp-range': 'timestamp',
  submit: 'submit',
}
